var map = {
	"./consulting/working-with-us_1.svg": "dM5E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HSl3";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/working\-with\-us_1\.svg$
// module id = HSl3
// module chunks = 0